import React from "react";
import { useFetch } from "@/lib/api";
import { PageHero } from "@/components/blocks/PageHero";
import { Reveal } from "@/components/blocks/Reveal";
import { DepartmentCard } from "@/components/cards/Cards";

const Departments = () => {
  const { data: depts } = useFetch("/departments");

  return (
    <div>
      <PageHero
        overline="Departments & Ministries"
        title="The teams behind the harvest"
        subtitle="Every department serves one goal — taking the Gospel to the nations and bringing the harvest home."
        image="https://images.unsplash.com/photo-1475527588268-e6a157656e35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <section className="bg-white py-24 md:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {(depts || []).map((d, i) => (
              <Reveal key={d.slug} delay={i * 0.05}>
                <DepartmentCard dept={d} />
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Departments;
